import React from 'react';
import { companyInfo } from '../mock';

const Footer = () => {
  return (
    <footer 
      style={{
        background: '#F7F5F0',
        borderTop: '1px solid rgba(13, 44, 34, 0.1)',
        padding: '60px 7.6923% 40px',
        marginTop: '100px'
      }}
    >
      <div 
        style={{
          maxWidth: '1400px',
          margin: '0 auto',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '40px',
          marginBottom: '40px'
        }}
      >
        <div>
          <h3 
            style={{
              fontSize: '20px',
              fontWeight: '600',
              color: '#0D2C22',
              marginBottom: '8px',
              letterSpacing: '-0.02em'
            }}
          >
            Logardt Group KB
          </h3>
          <p 
            style={{
              fontSize: '14px',
              color: 'rgba(13, 44, 34, 0.7)',
              lineHeight: '1.5',
              margin: '0 0 4px 0'
            }}
          >
            Godkänd för F-skatt
          </p>
          <p 
            style={{
              fontSize: '14px',
              color: 'rgba(13, 44, 34, 0.7)',
              lineHeight: '1.5',
              margin: '0 0 16px 0'
            }}
          >
            Godkänd för moms
          </p>
          <p 
            style={{
              fontSize: '16px',
              color: 'rgba(13, 44, 34, 0.85)',
              lineHeight: '1.5',
              margin: 0
            }}
          >
            Consulting Services
          </p>
        </div>
        
        <div>
          <h4 
            style={{
              fontSize: '18px',
              fontWeight: '600',
              color: '#0D2C22',
              marginBottom: '16px',
              letterSpacing: '-0.02em'
            }}
          >
            Get in Touch
          </h4>
          <p 
            style={{
              fontSize: '16px',
              color: 'rgba(13, 44, 34, 0.85)',
              margin: 0,
              lineHeight: '1.5'
            }}
          >
            Use the contact form above to reach us and we will get back to you shortly.
          </p>
        </div>
        
        <div>
          <h4 
            style={{
              fontSize: '18px',
              fontWeight: '600',
              color: '#0D2C22',
              marginBottom: '16px',
              letterSpacing: '-0.02em'
            }}
          >
            Collaborate With Us
          </h4>
          <p 
            style={{
              fontSize: '16px',
              color: 'rgba(13, 44, 34, 0.85)',
              margin: 0,
              lineHeight: '1.6'
            }}
          >
            Interested in collaborating with us on a project? Do not hesitate to reach out and discuss opportunities with us.
          </p>
        </div>
      </div>
      
      <div 
        style={{
          borderTop: '1px solid rgba(13, 44, 34, 0.1)',
          paddingTop: '24px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '20px'
        }}
      >
        <p 
          style={{
            fontSize: '16px',
            color: '#4D4D4D',
            margin: 0
          }}
        >
          © {new Date().getFullYear()} Logardt Group. All rights reserved.
        </p>
        
        <div style={{ display: 'flex', gap: '24px', flexWrap: 'wrap' }}>
          <a
            href="/terms"
            style={{
              fontSize: '14px',
              color: 'rgba(13, 44, 34, 0.7)',
              textDecoration: 'none',
              transition: 'color 0.3s ease'
            }}
            onMouseEnter={(e) => e.target.style.color = '#E5A93D'}
            onMouseLeave={(e) => e.target.style.color = 'rgba(13, 44, 34, 0.7)'}
          >
            Terms of Service
          </a>
          <a
            href="/privacy"
            style={{
              fontSize: '14px',
              color: 'rgba(13, 44, 34, 0.7)',
              textDecoration: 'none',
              transition: 'color 0.3s ease'
            }}
            onMouseEnter={(e) => e.target.style.color = '#E5A93D'}
            onMouseLeave={(e) => e.target.style.color = 'rgba(13, 44, 34, 0.7)'}
          >
            Privacy Policy
          </a>
          <a
            href="/cookies"
            style={{
              fontSize: '14px',
              color: 'rgba(13, 44, 34, 0.7)',
              textDecoration: 'none',
              transition: 'color 0.3s ease'
            }}
            onMouseEnter={(e) => e.target.style.color = '#E5A93D'}
            onMouseLeave={(e) => e.target.style.color = 'rgba(13, 44, 34, 0.7)'}
          >
            Cookies Policy
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
